/**
 * 统一头像组件（T02 / 架构 §8）
 *  - 有 avatar(dataURL) 渲染 <img>；否则首字母 SVG 兜底（背景色由 username 哈希派生）。
 *  - 全站人员头像统一走本组件，确保「上传头像优先、缺省首字母兜底」一致。
 */
import Box from '@mui/material/Box';
import { avatarSrc, initialsBg, initialsOf } from '../../utils/profile';
import type { PublicUser } from '../../types/models';

interface UserAvatarProps {
  user: Pick<PublicUser, 'username' | 'avatar' | 'nickname'> | null | undefined;
  size?: number;
  fontSize?: number;
}

export default function UserAvatar({ user, size = 40, fontSize }: UserAvatarProps) {
  const src = user ? avatarSrc(user) : null;
  const username = user?.username ?? '';
  const label =
    (user?.nickname && user.nickname.trim() ? user.nickname.trim()[0] : initialsOf(username)) ||
    '?';

  if (src) {
    return (
      <Box
        component="img"
        src={src}
        alt={username}
        sx={{
          width: size,
          height: size,
          borderRadius: '50%',
          objectFit: 'cover',
          display: 'block',
          flexShrink: 0,
        }}
      />
    );
  }

  return (
    <Box
      sx={{
        width: size,
        height: size,
        borderRadius: '50%',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        color: '#fff',
        fontWeight: 600,
        fontSize: fontSize ?? Math.round(size * 0.42),
        bgcolor: initialsBg(username || '?'),
        flexShrink: 0,
        userSelect: 'none',
      }}
      aria-label={username}
    >
      {label}
    </Box>
  );
}
